import { render } from "./InfoValidazioneCredito.vue?vue&type=template&id=1268994e&scoped=true"
import script from "./InfoValidazioneCredito.vue?vue&type=script&lang=js"
export * from "./InfoValidazioneCredito.vue?vue&type=script&lang=js"

import "./InfoValidazioneCredito.vue?vue&type=style&index=0&id=1268994e&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1268994e"]])

export default __exports__